import { ENV_CONFIGS, EnvConfigKey, Region, Env, ENV_CONFIG_KEYS } from './constants';

export const getEnvValue = (key: EnvConfigKey, env: Env, region: Region): string | never => {
  if (ENV_CONFIGS[region] && ENV_CONFIGS[region][env] && ENV_CONFIGS[region][env][key]) {
    return ENV_CONFIGS[region][env][key];
  }
  throw new Error(`Cannot find env config for env: ${env}, region: ${region} and key: ${key}`);
};

export const getApiBaseUrl = (containerId: string, env: Env, region: Region) => {
  const apigeeUrl = getEnvValue(ENV_CONFIG_KEYS.APIGEE_URL, env, region);
  const RFIsPath = getEnvValue(ENV_CONFIG_KEYS.RFIS_URL, env, region);
  const apiBaseUrl = `${apigeeUrl}${RFIsPath}/containers/${containerId}`;
  return apiBaseUrl;
};
